module.exports = __webpack_public_path__ + "prod/1.42.2/img/bannerForm3.18a41553.png";